// 2-oct-2026 · Complementos opcionales de la caja de compra del masajeador: almohada "con masajeador" (con cantidad)
// y +30 días de garantía. Las casillas las pinta snippets/zendo-complementos.liquid, debajo de los packs, sin marcar.
// - Cantidad: el selector "− 1 +" de la almohada va de 1 a las unidades del pack elegido y se ajusta al cambiar de pack.
// - Añadir: el formulario del tema (product-form.js) lanza un CartLinesUpdateEvent cuya promesa se resuelve con el
//   carrito ya actualizado. Si el masajeador entró sin error, cada complemento marcado se pone en una sola llamada a
//   /cart/update.js con la cantidad elegida; si el carrito ya tiene esa cantidad o más, no se toca (no se duplica
//   aunque se pulse dos veces). Se avisa al cajón con el mismo evento, como hace zendo-proteccion.js.
// - Topes en el carrito: si hay más almohadas "con masajeador" que masajeadores, más de 1 garantía o ningún masajeador,
//   snippets/zendo-complemento-huerfano.liquid pinta data-zc-orphan="variante:cantidad,..." en el resumen del carrito
//   y aquí se ponen esas cantidades. Por eso este script se carga en todas las páginas.
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const root = window.Shopify?.routes?.root || '/';
let busy = false;
// 4-oct-2026 · Vuelve el carrito (Carlos: "la idea es que la gente cuando entre pueda ver más productos").
// "Comprar ahora" sigue llevando directo a la pasarela de pago; el botón secundario "Añadir al carrito" mete lo
// mismo (pack + complementos marcados) y abre el cajón del carrito para seguir comprando.
let soloCarrito = false;

function openCartDrawer() {
  const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
  if (trigger) trigger.click();
  else window.location.assign(`${root}cart`);
}

function ensureCartButtons() {
  for (const form of document.querySelectorAll('product-form-component')) {
    if (form.querySelector('.zendo-anadir-carrito')) continue;
    const submit = form.querySelector('button[type="submit"]');
    if (!submit) continue;
    const anchor = submit.closest('add-to-cart-component') || submit;
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'zendo-anadir-carrito';
    button.textContent = (window.zendoTextos && window.zendoTextos.anadirCarrito) || 'Añadir al carrito';
    button.addEventListener('click', () => {
      soloCarrito = true;
      submit.click();
    });
    anchor.insertAdjacentElement('afterend', button);
  }
}

if (!document.getElementById('zendo-anadir-carrito-css')) {
  const style = document.createElement('style');
  style.id = 'zendo-anadir-carrito-css';
  style.textContent =
    '.zendo-anadir-carrito{display:block;width:100%;margin-top:8px;padding:13px 16px;border-radius:var(--style-border-radius-buttons-primary,10px);' +
    'border:1.5px solid #2f3d2c;background:transparent;color:#2f3d2c;font:inherit;font-weight:700;cursor:pointer}' +
    '.zendo-anadir-carrito:hover{background:rgb(47 61 44 / .06)}';
  document.head.appendChild(style);
}
ensureCartButtons();
new MutationObserver(ensureCartButtons).observe(document.body, { childList: true, subtree: true });

function cartSectionIds() {
  const ids = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId);
  return [...new Set(ids.filter(Boolean))];
}

async function cartItems() {
  const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error(`cart fetch failed: ${response.status}`);
  return (await response.json()).items;
}

// Pone las cantidades de `updates` ({ variantId: cantidad }) y avisa al carrito.
async function setLines(updates, action) {
  const ids = Object.keys(updates);
  if (busy || !ids.length) return;
  busy = true;
  const deferred = CartLinesUpdateEvent.createPromise();
  const key = action === 'add' ? 'merchandiseId' : 'id';
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action,
      context: action === 'add' ? 'product' : 'cart',
      lines: ids.map((id) => ({ [key]: id, quantity: updates[id] })),
      promise: deferred.promise,
    })
  );

  try {
    const sections = cartSectionIds();
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: sections.join(','), sections_url: window.location.pathname }),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || 'cart update failed');

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(data),
      detail: { items: data.items, sections: data.sections ?? undefined, source: 'zendo-complemento' },
    });
  } catch (error) {
    deferred.reject(error);
    console.warn('[zendo-complemento]', error);
  } finally {
    busy = false;
  }
}

// Unidades del pack elegido (1, 2 o 3) en el selector de packs de ese producto.
function packUnits(productId) {
  const radio = document.querySelector(`variant-picker[data-product-id="${productId}"] .bz-offres__radio:checked`);
  return Math.max(1, Number(radio?.dataset.zcUnits) || parseInt(radio?.value ?? '', 10) || 1);
}

function syncQty(box) {
  const out = box.querySelector('[data-zc-qty]');
  if (!out) return 1;
  const max = packUnits(box.dataset.zcFor);
  const value = Math.min(Math.max(1, Number(out.textContent) || 1), max);
  out.textContent = String(value);
  box.querySelector('[data-zc-step="-1"]').disabled = value <= 1;
  box.querySelector('[data-zc-step="1"]').disabled = value >= max;
  return value;
}

function syncAll() {
  document.querySelectorAll('.zendo-comp').forEach(syncQty);
}

document.addEventListener('click', (event) => {
  const step = event.target instanceof Element ? event.target.closest('[data-zc-step]') : null;
  const box = step?.closest('.zendo-comp');
  const out = box?.querySelector('[data-zc-qty]');
  if (!out) return;
  out.textContent = String((Number(out.textContent) || 1) + Number(step.dataset.zcStep));
  syncQty(box);
});

document.addEventListener('change', (event) => {
  if (event.target instanceof Element && event.target.matches('.bz-offres__radio')) syncAll();
});

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  const form = event.target;
  if (!(form instanceof HTMLElement) || form.localName !== 'product-form-component' || event.action !== 'add') return;

  // Casillas y cantidades se leen al pulsar el botón, no cuando responde el carrito.
  const wanted = {};
  for (const box of document.querySelectorAll(`.zendo-comp[data-zc-for="${form.dataset.productId}"]`)) {
    const input = box.querySelector('.zendo-comp__input');
    if (!input?.checked || input.disabled || !input.dataset.zcVariant) continue;
    wanted[input.dataset.zcVariant] = syncQty(box);
  }
  // 6-oct-2026 · Packs con talla (corrector y faja, blocks/zendo-packs-talla.liquid).
  const packBox = document.querySelector(`.zendo-packs-t[data-product-id="${form.dataset.productId}"]`);
  if (packBox) {
    const pack = packT[form.dataset.productId];
    if (pack === 'espalda') {
      const extra = packBox.querySelector('[data-zpt-extra]')?.value;
      if (extra) wanted[extra] = 1;
    } else if (pack === 'duo') {
      const vid = form.querySelector('input[name="id"]')?.value;
      if (vid) wanted[vid] = 2;
    }
  }
  // 8-oct-2026 · Lo elegido en este clic, para que "Comprar ahora" no arrastre lo que ya había en el carrito.
  const elegido = { ...wanted };
  const mainId = form.querySelector('input[name="id"]')?.value;
  if (mainId) elegido[mainId] = Math.max(elegido[mainId] ?? 0, Number(form.querySelector('input[name="quantity"]')?.value) || 1);
  event.promise
    ?.then(async ({ detail }) => {
      if (detail?.didError) {
        soloCarrito = false;
        return;
      }
      if (Object.keys(wanted).length) {
        const inCart = {};
        for (const item of detail?.items ?? (await cartItems())) {
          const id = String(item.variant_id);
          inCart[id] = (inCart[id] ?? 0) + item.quantity;
        }
        const updates = Object.fromEntries(Object.entries(wanted).filter(([id, quantity]) => (inCart[id] ?? 0) < quantity));
        if (Object.keys(updates).length) await setLines(updates, 'add');
      }
      // 3-oct-2026 · "Comprar ahora" (consejo de Dylan a Carlos: muchos carritos y pocos pagos): del botón directo a la
      // pasarela de pago, sin pasar por el carrito. Desde el 4-oct, "Añadir al carrito" abre el cajón en su lugar.
      if (soloCarrito) {
        soloCarrito = false;
        openCartDrawer();
        return;
      }
      // 8-oct-2026 · El enlace /cart/id:cantidad sustituye el carrito: el pago muestra solo lo elegido (17 pagos, 1 compra).
      window.location.assign(`${root}cart/${Object.entries(elegido).map(([id, quantity]) => `${id}:${quantity}`).join(',')}`);
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[zendo-complemento]', error);
    });
});

function removeOrphans() {
  const orphan = document.querySelector('[data-zc-orphan]:not([data-zc-done])');
  if (!orphan || busy) return;
  orphan.dataset.zcDone = '1';
  const updates = {};
  for (const pair of orphan.dataset.zcOrphan.split(',').filter(Boolean)) {
    const [id, quantity = '0'] = pair.split(':');
    updates[id] = Number(quantity) || 0;
  }
  setLines(updates, 'update');
}

new MutationObserver(removeOrphans).observe(document.documentElement, { childList: true, subtree: true });
removeOrphans();
syncAll();

// 6-oct-2026 · Packs con almohada (auditoría CRO). Las tarjetas .zendo-pack (snippets/zendo-pack-card.liquid) no son
// variantes: al elegir una se marca la variante de n unidades y la fila OCULTA de la almohada "con masajeador"
// ([data-zc-pack-almohada]), que el código de arriba mete en el carrito con el pack. Al elegir una tarjeta normal se
// quita la almohada. Tras el refresco de la sección (cambio de variante) se vuelve a pintar el pack elegido.
let packActivo = null; // { product: id, units: n }
let desdePack = false;

function almohadaPack(productId) {
  return document.querySelector(`[data-zc-pack-almohada] .zendo-comp[data-zc-for="${productId}"]`);
}

function setAlmohada(productId, on) {
  const box = almohadaPack(productId);
  const input = box?.querySelector('.zendo-comp__input');
  if (!input) return;
  if (input.checked !== on) input.checked = on;
  const out = box.querySelector('[data-zc-qty]');
  if (out && out.textContent !== '1') out.textContent = '1';
}

// El precio grande de la cabecera (<product-price>) muestra el del pack elegido y vuelve al de la variante al quitarlo.
function paintPrice(picker, card) {
  const pp = picker.closest('.shopify-section')?.querySelector('product-price');
  const bdis = pp ? [...pp.querySelectorAll('bdi')] : [];
  if (!bdis.length) return;
  if (card) {
    const price = card.querySelector('.bz-offres__price')?.textContent.trim();
    const compare = card.querySelector('.bz-offres__compare')?.textContent.trim();
    if (!pp.dataset.zpOrig) pp.dataset.zpOrig = JSON.stringify(bdis.map((b) => b.textContent));
    if (price && bdis[0].textContent !== price) bdis[0].textContent = price;
    if (compare && bdis[1] && bdis[1].textContent !== compare) bdis[1].textContent = compare;
  } else if (pp.dataset.zpOrig) {
    const orig = JSON.parse(pp.dataset.zpOrig);
    bdis.forEach((b, i) => {
      if (orig[i] != null && b.textContent !== orig[i]) b.textContent = orig[i];
    });
    delete pp.dataset.zpOrig;
  }
}

// 6-oct-2026 (Carlos: "3. Vale"): al entrar en la ficha, el Pack Cuello Completo sale ya marcado si la variante
// elegida es la de 1 unidad. Solo una vez por carga: si la persona elige otra tarjeta, no se vuelve a marcar.
let packInicial = false;

function paintPacks() {
  for (const picker of document.querySelectorAll('variant-picker.bz-offres')) {
    const pid = picker.dataset.productId;
    if (!packInicial && picker.querySelector('.zendo-pack[data-pack-units="1"]')) {
      packInicial = true;
      const radio = picker.querySelector('.bz-offres__radio:checked');
      if (!packActivo && Number(radio?.dataset.zcUnits) === 1) packActivo = { product: pid, units: 1 };
    }
    const on = Boolean(packActivo && String(packActivo.product) === String(pid));
    if (picker.classList.contains('zendo-packs-on') !== on) picker.classList.toggle('zendo-packs-on', on);
    for (const card of picker.querySelectorAll('.zendo-pack')) {
      const sel = on && Number(card.dataset.packUnits) === packActivo.units;
      if (card.classList.contains('is-selected') !== sel) card.classList.toggle('is-selected', sel);
      const aria = sel ? 'true' : 'false';
      if (card.getAttribute('aria-checked') !== aria) card.setAttribute('aria-checked', aria);
    }
    if (on) setAlmohada(pid, true);
    paintPrice(picker, on ? picker.querySelector('.zendo-pack.is-selected') : null);
  }
}

function elegirPack(card) {
  const picker = card.closest('variant-picker');
  if (!picker) return;
  const units = Number(card.dataset.packUnits) || 1;
  packActivo = { product: picker.dataset.productId, units };
  const radio = picker.querySelector(`.bz-offres__radio[data-zc-units="${units}"]`);
  if (radio && !radio.checked) {
    desdePack = true;
    radio.click();
    desdePack = false;
  }
  paintPacks();
}

document.addEventListener('click', (event) => {
  const el = event.target instanceof Element ? event.target : null;
  const pack = el?.closest('.zendo-pack');
  if (pack) {
    event.preventDefault();
    elegirPack(pack);
    return;
  }
  // Tarjeta normal (1 unidad o Dúo): fuera el pack y la almohada, aunque la variante ya estuviera marcada.
  const card = el?.closest('.bz-offres__card');
  if (card && packActivo && !desdePack) {
    const pid = packActivo.product;
    packActivo = null;
    setAlmohada(pid, false);
    paintPacks();
  }
});

document.addEventListener('keydown', (event) => {
  if ((event.key === 'Enter' || event.key === ' ') && event.target instanceof Element && event.target.matches('.zendo-pack')) {
    event.preventDefault();
    elegirPack(event.target);
  }
});

new MutationObserver(paintPacks).observe(document.body, { childList: true, subtree: true });

// 6-oct-2026 · Una sola recomendación en el carrito (snippets/zendo-upsell-carrito.liquid): botón "Añadir".
document.addEventListener('click', (event) => {
  const btn = event.target instanceof Element ? event.target.closest('[data-zendo-upsell]') : null;
  if (!btn) return;
  event.preventDefault();
  btn.disabled = true;
  setLines({ [btn.dataset.zendoUpsell]: 1 }, 'add');
});

// 6-oct-2026 · Packs con talla (corrector y faja): uno / Pack Espalda (marcado al entrar) / Dúo. Ver blocks/zendo-packs-talla.liquid.
const packT = {};
function paintPacksT() {
  for (const box of document.querySelectorAll('.zendo-packs-t')) {
    const pid = box.dataset.productId;
    if (!(pid in packT)) packT[pid] = box.dataset.zptDefault || 'uno';
    let elegida = null;
    for (const card of box.querySelectorAll('[data-zpt]')) {
      const sel = card.dataset.zpt === packT[pid];
      if (sel) elegida = card;
      if (card.classList.contains('is-selected') !== sel) card.classList.toggle('is-selected', sel);
      const aria = sel ? 'true' : 'false';
      if (card.getAttribute('aria-checked') !== aria) card.setAttribute('aria-checked', aria);
    }
    paintPrice(box, packT[pid] === 'uno' ? null : elegida);
  }
}
document.addEventListener('click', (event) => {
  const card = event.target instanceof Element ? event.target.closest('.zendo-pack-t') : null;
  if (!card) return;
  const box = card.closest('.zendo-packs-t');
  packT[box.dataset.productId] = card.dataset.zpt;
  paintPacksT();
});
document.addEventListener('keydown', (event) => {
  if ((event.key === 'Enter' || event.key === ' ') && event.target instanceof Element && event.target.matches('.zendo-pack-t')) {
    event.preventDefault();
    event.target.click();
  }
});
new MutationObserver(paintPacksT).observe(document.body, { childList: true, subtree: true });
paintPacksT();

// 7-oct-2026 · "Elige tu talla": las fichas con talla (corrector y faja) no llevan ninguna marcada hasta que el cliente la toca,
// y el texto "Talla X" de las tarjetas sigue a la talla elegida. La variante real no se toca (Horizon sigue con la primera):
// solo se oculta su marca y se bloquea "Añadir al carrito" hasta el primer clic en una talla.
let tallaElegida = false;
function tallaActual() {
  const r = document.querySelector('.variant-option--buttons input[name^="Talla"]:checked');
  return r ? r.value : '';
}
function syncTalla() {
  const hay = document.querySelector('.zendo-packs-t');
  const root = document.documentElement;
  if (!hay) { if (root.hasAttribute('data-zendo-sin-talla')) root.removeAttribute('data-zendo-sin-talla'); return; }
  const pendiente = !tallaElegida;
  if (pendiente !== root.hasAttribute('data-zendo-sin-talla')) root.toggleAttribute('data-zendo-sin-talla', pendiente);
  const valor = pendiente ? '—' : tallaActual();
  for (const el of document.querySelectorAll('[data-zpt-talla]')) {
    if (valor && el.textContent !== valor) el.textContent = valor;
  }
  const fs = document.querySelector('.variant-option--buttons:has(input[name^="Talla"])');
  let msg = document.querySelector('.zendo-elige-talla');
  if (fs && pendiente && !msg) {
    msg = document.createElement('p');
    msg.className = 'zendo-elige-talla';
    msg.textContent = 'Elige tu talla para añadirlo al carrito';
    fs.insertAdjacentElement('afterend', msg);
  } else if (msg && (!pendiente || !fs)) {
    msg.remove();
  }
}
document.addEventListener('click', (event) => {
  const lab = event.target instanceof Element ? event.target.closest('.variant-option--buttons .variant-option__button-label') : null;
  if (lab && lab.querySelector('input[name^="Talla"]')) { tallaElegida = true; setTimeout(syncTalla, 0); setTimeout(syncTalla, 400); }
});
document.addEventListener('change', (event) => {
  if (event.target instanceof Element && event.target.matches('input[name^="Talla"]')) { tallaElegida = true; setTimeout(syncTalla, 0); setTimeout(syncTalla, 400); }
});
new MutationObserver(syncTalla).observe(document.body, { childList: true, subtree: true });
syncTalla();
